import ExcelUploadPageContainer from './excel-upload-page-container';

export default ExcelUploadPageContainer;